import React from 'react';
import { Screen, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BackButton, Center } from '~/commonComponents';
import { FeaturesSection, ProcessStepsSection } from './components';

export const HowItWorksScreen: React.FC = () => {
  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="How It Works">
        <Center marginBottom={32} maxWidth={640}>
          <Typography as="span" size="body_large" textAlign="center" color={colors.neutral[500]}>
            GoTu connects you with licensed, verified dental professionals, on your schedule and at
            your rate. You post the shift, approve the day, and we handle the rest. It&apos;s that
            simple.
          </Typography>
        </Center>
      </Screen.Header>
      <Screen.Body>
        <FeaturesSection />
        <ProcessStepsSection />
      </Screen.Body>
    </Screen>
  );
};
